import { memo } from 'react';
import { css } from '@emotion/react';
import { ComponentIcon } from 'client/sections/components/ComponentIcon';

export const ComponentInputLabel = memo(
  ({ name, componentName, packageUrl }: { name?: string; componentName: string; packageUrl: string }) => (
    <div css={labelStyle}>
      <ComponentIcon url={packageUrl} type="component" hideType />
      {componentName}
      {name ? ` — ${name}` : ''}
    </div>
  )
);

const labelStyle = css`
  position: relative;
  display: flex;
  padding-left: 26px;

  > figure {
    position: absolute;
    top: -2px;
    left: -6px;
    scale: 0.6;
  }
`;
